export const avatarColors = [
  "#166a2c",
  "#d1af29",
  "#856a51",
  "#ae5f43",
  "linear-gradient(to left, #675848, #706152 0%)",
  "#517085",
  "#16216a",
  "#df1845"
];
